import PropTypes from "prop-types"
import { CalendarMonth } from "@mui/icons-material"
import { formatEventTime, formatEventDate } from "../../../utils/dateFormatter"
import { H5, Body3, Body2, H6 } from "../../../themes/typography"
import "../../../styles/event/TicketBookingOrder.css"

const demoTicketSchedule = [
    {
        id: 1,
        date: '2026-12-25',
        from_time: '10:00:00',
        to_time: '11:00:00'
    },
    {
        id: 2,
        date: '2026-12-26',
        from_time: '10:00:00',
        to_time: '11:00:00'
    },
    {
        id: 3,
        date: '2026-12-27',
        from_time: '10:00:00',
        to_time: '11:00:00'
    },
    {
        id: 4,
        date: '2026-12-28',
        from_time: '10:00:00',
        to_time: '11:00:00'
    },
    {
        id: 5,
        date: '2026-12-29',
        from_time: '10:00:00',
        to_time: '11:00:00'
    }
]

export default function UserPurchaseTicket({
    name,
    description,
    validFor,
    attendeeName,
    id
}) {
    return (
        <div id="user-order-ticket-card-container">

            <div className="user-order-ticket-wrapper">

                <div className="user-order-ticket-details">
                    <div className="user-order-ticket-details-wrapper">

                        <div className="user-order-ticket-info">
                            <div className="user-order-ticket-info-title">
                                <H5
                                    color="var(--secondary-color)"
                                    fontWeight={700}
                                >
                                    {name}
                                </H5>
                            </div>
                            <div className="user-order-ticket-info-description">
                                <Body3>
                                    {description}
                                </Body3>
                            </div>
                        </div>

                        <div className="user-order-ticket-validity">
                            <div className="user-order-ticket-validity-title">
                                <H5 color="var(--secondary-color)" fontWeight={700}>
                                    Ticket valid for
                                </H5>
                            </div>
                            <div className="user-order-ticket-validity-info">
                                {validFor?.map((slot) => (
                                    <ValidDateSlot
                                        key={slot.id}
                                        date={slot.date}
                                        fromTime={slot.from_time}
                                        toTime={slot.to_time}
                                    />
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

                <div className="user-order-ticket-cuts">

                    <div className="user-order-ticket-top-cut"></div>
                    <div className="user-order-ticket-top-center"></div>
                    <div className="user-order-ticket-top-bottom"></div>
                </div>

                <div className="user-order-ticket-owner-details">
                    <div className="user-order-ticket-owner-details-wrapper">

                        <div className="user-order-ticket-number-details">
                            <div className="user-order-ticket-number-details-label">
                                <Body2 fontWeight={300}>
                                    Ticket No.
                                </Body2>
                            </div>
                            <div className="user-order-ticket-number-details-value">
                                <H6 color="var(--secondary-color)">
                                    {id}
                                </H6>
                            </div>
                        </div>

                        <div className="user-order-ticket-owner-name">
                            <H6
                                fontWeight={600}
                                color="var(--secondary-color)"
                            >
                                {attendeeName}
                            </H6>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

function ValidDateSlot({
    date = '2025-12-25',
    fromTime = '10:00:00',
    toTime = '11:00:00'
}) {
    return (
        <div className="user-order-ticket-validity-info-slot">
            <div className="user-order-ticket-validity-info-slot-icon">
                <CalendarMonth
                    style={{
                        fontSize: '1.125rem',
                        color: 'var(--tertiary-color)'
                    }}
                />
            </div>
            <div className="user-order-ticket-validity-info-slot-text">
                <Body3 fontWeight={400}>
                    {formatEventDate(date)}
                </Body3>
                <Body3>
                    {formatEventTime(date, fromTime)} - {formatEventTime(date, toTime)}
                </Body3>
            </div>
        </div>
    )
}


/**
 * Validation for props of UserPurchaseTicket component
 * name: string - The name of the ticket.
 * description: string - The description of the ticket.
 * validFor: array - The valid time slots for the ticket.
 * Each slot is an object with the following properties:
 *   id: number|string - The unique identifier for the slot.
 *   date: string - The date of the slot in 'YYYY-MM-DD' format.
 *   from_time: string - The start time of the slot in 'HH:MM:SS' format.
 *   to_time: string - The end time of the slot in 'HH:MM:SS' format.
 */
UserPurchaseTicket.propTypes = {
    name: PropTypes.string,
    description: PropTypes.string,
    validFor: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string
        ]),
        date: PropTypes.string,
        from_time: PropTypes.string,
        to_time: PropTypes.string
    }))
}


/**
 * Validation for props of ValidDateSlot component
 * date: string - The date of the slot in 'YYYY-MM-DD' format.
 * fromTime: string - The start time of the slot in 'HH:MM:SS' format.
 * toTime: string - The end time of the slot in 'HH:MM:SS' format.
 */
ValidDateSlot.propTypes = {
    date: PropTypes.string,
    fromTime: PropTypes.string,
    toTime: PropTypes.string
}